export default __webpack_public_path__ + "static/media/noti.fc8f66ff.svg";